// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section___TusU","sectionContent":"Section_sectionContent__QrTDs","sectionIcon":"Section_sectionIcon__XwqRR"};